class HosPreorderPopup extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

    const form = () => document.getElementById(this.dataset.formId);
    const noticeButton = () => form()?.querySelector('[data-preorder-open]');
    const close = () => this.dialog.close();
    this.querySelector('[data-preorder-close]')?.addEventListener('click', close, { signal });
    this.querySelector('[data-preorder-continue]')?.addEventListener('click', () => {
      close();
      const target = form()?.querySelector('button[name="add"]:not(:disabled)') || noticeButton();
      target?.scrollIntoView({ behavior: 'instant', block: 'center' });
      target?.focus({ preventScroll: true });
    }, { signal });
    this.dialog.addEventListener('click', (event) => {
      if (event.target !== this.dialog) return;
      const bounds = this.dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    }, { signal });
    this.dialog.addEventListener('close', () => {
      if (document.activeElement === document.body || this.dialog.contains(document.activeElement)) {
        noticeButton()?.focus({ preventScroll: true });
      }
    }, { signal });
    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('[data-preorder-open]') : null;
      if (trigger?.dataset.preorderOpen === this.dialog.id) this.open();
    }, { signal });

    // The component is outside the variant form, so choosing a size does not reopen it.
    this.frame = requestAnimationFrame(() => this.openWhenReady(signal));
  }

  openWhenReady(signal) {
    if (!this.isConnected || signal.aborted) return;
    const otherDialog = document.querySelector('dialog[open]');
    if (otherDialog && otherDialog !== this.dialog) {
      otherDialog.addEventListener('close', () => this.openWhenReady(signal), { once: true, signal });
      return;
    }
    this.open();
  }

  open() {
    if (this.isConnected && !this.dialog.open) this.dialog.showModal();
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
  }
}

if (!customElements.get('hos-preorder-popup')) {
  customElements.define('hos-preorder-popup', HosPreorderPopup);
}
